export const ANONYMOUS_USER_ID = 'PublicAnonymousUser';
export const ANONYMOUS_USER_EMAIL = 'publicanonymoususer@ans.com';
export const ANONYMOUS_USER_FIRST_NAME = 'Public';
export const ANONYMOUS_USER_LAST_NAME = 'Anonymous';

export type FullStoryUserInfo = {
  uid: string;
  properties: Record<string, string>;
};

function withOptionalFirmName(properties: Record<string, string>, firmName?: string): Record<string, string> {
  const trimmedFirmName = firmName?.trim();
  if (!trimmedFirmName) {
    return properties;
  }

  return { ...properties, firmName: trimmedFirmName };
}

export function buildAnonymousFullStoryUser(firmName?: string): FullStoryUserInfo {
  return {
    uid: ANONYMOUS_USER_ID,
    properties: withOptionalFirmName(
      {
        email: ANONYMOUS_USER_EMAIL,
        firstName: ANONYMOUS_USER_FIRST_NAME,
        lastName: ANONYMOUS_USER_LAST_NAME,
      },
      firmName,
    ),
  };
}

export type ProductFruitsUserInfo = {
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  signUpAt: string;
  role: string;
  props: Record<string, string>;
};

export function buildAnonymousProductFruitsUser(firmName?: string): ProductFruitsUserInfo {
  const trimmedFirmName = firmName?.trim();
  const props: Record<string, string> = {};

  if (trimmedFirmName) {
    props.firmName = trimmedFirmName;
  }

  return {
    username: ANONYMOUS_USER_ID,
    email: ANONYMOUS_USER_EMAIL,
    firstname: ANONYMOUS_USER_FIRST_NAME,
    lastname: ANONYMOUS_USER_LAST_NAME,
    signUpAt: '',
    role: 'user',
    props,
  };
}
